import { ShieldCheck, Star, Zap, Trophy, Flame, Lock, ChevronRight, Crown, Eye, Sliders } from "lucide-react";
import { Link } from "react-router-dom";

const HERO_BG = "https://images.unsplash.com/photo-1626836014893-37663794dca7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxhbWVyaWNhbiUyMGZsYWclMjBkcmFtYXRpY3xlbnwwfHx8fDE3ODA0MTA5NjR8MA&ixlib=rb-4.1.0&q=85";
const EAGLE = "https://images.pexels.com/photos/5503727/pexels-photo-5503727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const GOLD = "https://images.pexels.com/photos/14331332/pexels-photo-14331332.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const TESTIMONIALS = [
  {
    name: "Earl B., Tulsa OK",
    quote: "I doubled my donation faster than my third marriage ended. Patriotic!",
    rank: "PLATINUM PATRIOT",
  },
  {
    name: "Wanda S., Branson MO",
    quote: "The pop-up that screamed at me felt like home. 10 stars. No notes.",
    rank: "DIAMOND EAGLE",
  },
  {
    name: "Buck T., Lubbock TX",
    quote: "Donated $200 in pure freedom dollars. My truck is now bigger. Coincidence?",
    rank: "GOLD HOMBRE",
  },
];

export default function DesignA({
  donors,
  doubleIt,
  setDoubleIt,
  supporterName,
  setSupporterName,
  supporterEmail,
  setSupporterEmail,
  consentToDisplay,
  setConsentToDisplay,
  customAmount,
  setCustomAmount,
  startCheckout,
  loading,
}) {
  const total = doubleIt ? 200 : 100;

  return (
    <main data-testid="design-a-root" className="relative overflow-hidden">
      {/* ============== HERO ============== */}
      <section className="relative min-h-[100vh] grain">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${HERO_BG})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050b14]/85 via-[#050b14]/70 to-[#050b14]" />
        <div className="absolute inset-0 stars-bg opacity-60" />

        {/* Top bar */}
        <div className="relative z-10 pt-24 px-6">
          {/* Marquee ticker */}
          <div className="max-w-7xl mx-auto mb-10 overflow-hidden border-y border-[#ffd700]/40 bg-black/40 backdrop-blur-sm">
            <div className="flex marquee-track whitespace-nowrap py-2">
              {[...donors, ...donors].map((d, i) => (
                <span
                  key={i}
                  className="font-accent text-[11px] tracking-[0.2em] text-[#ffd700] px-6"
                >
                  ★ {d.name} from {d.location} just donated ${d.amount} · {d.minutes_ago}m ago ★
                </span>
              ))}
              {donors.length === 0 && (
                <span className="font-accent text-[11px] tracking-[0.2em] text-[#ffd700] px-6">
                  ★ LIVE PATRIOT TICKER WARMING UP ★ EAGLES INBOUND ★
                </span>
              )}
            </div>
          </div>

          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#ffd700]/50 bg-[#0a3161]/40">
                <Flame size={12} className="text-[#ffd700] blink" />
                <span className="font-accent text-[10px] tracking-[0.3em] text-[#ffd700]">
                  LIMITED TIME · 100% PARODY · 0% REFUNDS
                </span>
              </div>

              <h1 className="mt-6 font-display text-[64px] md:text-[88px] lg:text-[108px] leading-[0.95] font-black">
                <span className="gold-text">DONATE.</span>
                <br />
                <span className="text-white">DOUBLE IT.</span>
                <br />
                <span className="gold-text">FEEL</span>{" "}
                <span className="font-accent text-[#b22234] italic">UNSTOPPABLE.</span>
              </h1>

              <p className="mt-8 max-w-xl text-[#cbd5e1] text-base md:text-lg leading-relaxed">
                The Official™ Patriot Bonus Drive is now accepting{" "}
                <span className="text-[#ffd700] font-semibold">freedom dollars</span>.
                Donate <span className="font-accent text-white">$100</span> — or because
                you're a true winner — <span className="font-accent text-[#ffd700]">DOUBLE IT TO $200</span> and
                receive your Gold Platinum Diamond Eagle Status (digital, non-existent, but real to you).
              </p>

              <div className="mt-8 flex flex-wrap items-center gap-6">
                <Trust icon={ShieldCheck} text="100% Secure Patriot Encryption" />
                <Trust icon={Lock} text="Bank-Grade Eagle Vault" />
                <Trust icon={Crown} text="VIP Bonus Tier Unlocked" />
              </div>
            </div>

            {/* Donation card */}
            <div className="lg:col-span-5">
              <div className="relative">
                <div
                  className="absolute -top-6 -right-6 w-28 h-28 rounded-full bg-cover bg-center border-4 border-[#ffd700] shadow-[0_0_40px_rgba(255,215,0,0.5)] z-20 rotate-6"
                  style={{ backgroundImage: `url(${EAGLE})` }}
                  aria-hidden
                />
                <div className="relative rounded-sm bg-[#0a1628] gold-border p-7 md:p-9">
                  <div className="flex items-center justify-between mb-5">
                    <span className="font-accent text-[11px] tracking-[0.3em] text-[#ffd700]">
                      OFFICIAL DONATION VAULT
                    </span>
                    <span className="text-[10px] uppercase tracking-widest text-white/50">
                      Tier · MEGA
                    </span>
                  </div>

                  <div className="text-center py-4">
                    <div className="font-accent text-[110px] leading-none gold-text">
                      ${total}
                    </div>
                    <div className="font-accent text-[12px] tracking-[0.4em] text-[#ffd700] mt-2">
                      {doubleIt ? "DOUBLED · DIAMOND PATRIOT" : "STANDARD PATRIOT"}
                    </div>
                  </div>

                  {/* Double it toggle */}
                  <button
                    data-testid="double-it-toggle-a"
                    onClick={() => setDoubleIt(!doubleIt)}
                    className={
                      "w-full mt-4 relative overflow-hidden font-accent text-[15px] tracking-[0.25em] py-4 border-2 transition-all " +
                      (doubleIt
                        ? "bg-gradient-to-r from-[#ffd700] via-[#fff4a3] to-[#ffd700] text-[#050b14] border-[#ffd700]"
                        : "bg-transparent text-[#ffd700] border-[#ffd700]/60 hover:bg-[#ffd700]/10")
                    }
                  >
                    <span className="relative z-10">
                      {doubleIt ? "✓ DOUBLED TO $200 · LEGENDARY MOVE" : "⚡ DOUBLE IT TO $200 ⚡"}
                    </span>
                  </button>

                  <input
                    data-testid="supporter-name-input-a"
                    value={supporterName}
                    onChange={(e) => setSupporterName(e.target.value)}
                    placeholder="Your Patriot Name (optional)"
                    className="w-full mt-4 bg-[#050b14] border border-[#ffd700]/40 text-white placeholder:text-white/30 px-4 py-3 focus:outline-none focus:border-[#ffd700] font-display"
                  />

                  <input
                    data-testid="supporter-email-input-a"
                    type="email"
                    value={supporterEmail}
                    onChange={(e) => setSupporterEmail(e.target.value)}
                    placeholder="Email for receipt (optional but recommended)"
                    className="w-full mt-3 bg-[#050b14] border border-[#ffd700]/40 text-white placeholder:text-white/30 px-4 py-3 focus:outline-none focus:border-[#ffd700] font-display"
                  />

                  <label className="mt-3 flex items-start gap-3 cursor-pointer group">
                    <input
                      data-testid="consent-to-display-a"
                      type="checkbox"
                      checked={consentToDisplay}
                      onChange={(e) => setConsentToDisplay(e.target.checked)}
                      className="mt-1 w-4 h-4 accent-[#ffd700]"
                    />
                    <span className="text-[11px] text-white/70 leading-snug group-hover:text-white/90">
                      Display me on the{" "}
                      <Link
                        to="/wall"
                        target="_blank"
                        className="text-[#ffd700] underline underline-offset-2 hover:text-white"
                      >
                        Patriot Wall of Fame
                      </Link>{" "}
                      (first name + tier only).
                    </span>
                  </label>

                  <button
                    data-testid="donate-button-a"
                    onClick={() => startCheckout()}
                    disabled={loading}
                    className="pulse-cta w-full mt-5 bg-gradient-to-b from-[#b22234] to-[#8b1827] hover:from-[#c92a40] hover:to-[#b22234] text-white font-accent text-[20px] tracking-[0.2em] py-5 border-2 border-[#ffd700] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {loading ? "LAUNCHING EAGLES…" : `DONATE $${total} NOW →`}
                  </button>

                  <div className="mt-5 flex items-center justify-center gap-4 text-[10px] uppercase tracking-widest text-white/50">
                    <span>VISA</span>
                    <span>•</span>
                    <span>MASTERCARD</span>
                    <span>•</span>
                    <span>AMEX</span>
                    <span>•</span>
                    <span>BALD EAGLE PAY</span>
                  </div>
                </div>

                {/* Floating gold ribbon */}
                <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#b22234] px-5 py-2 rotate-[-3deg] border-2 border-[#ffd700] shadow-xl">
                  <span className="font-accent text-[12px] tracking-[0.3em] text-[#ffd700]">
                    PARODY EDITION · 2026
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============== STATS BAR ============== */}
      <section className="relative z-10 bg-[#0a3161] border-y-4 border-[#ffd700]">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4">
          {[
            { v: "9,847,221", l: "Eagles Released" },
            { v: "$420.69M", l: "Freedom Dollars" },
            { v: "1776", l: "VIP Patriots" },
            { v: "∞", l: "Pure Glory" },
          ].map((s, i) => (
            <div
              key={i}
              className="px-6 py-7 text-center border-r border-[#ffd700]/30 last:border-r-0"
            >
              <div className="font-display text-3xl md:text-4xl gold-text font-black">{s.v}</div>
              <div className="font-accent text-[10px] tracking-[0.3em] text-white/80 mt-1">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ============== TESTIMONIALS ============== */}
      <section className="relative px-6 py-24 bg-[#050b14]">
        <div className="absolute inset-0 stars-bg opacity-30 pointer-events-none" />
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-3">
            <Star size={14} className="text-[#ffd700]" />
            <span className="font-accent text-[11px] tracking-[0.4em] text-[#ffd700]">
              WHAT REAL PATRIOTS™ SAY
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl font-black gold-text max-w-3xl">
            Verified Eagle-Approved Testimonials
          </h2>
          <p className="text-white/60 max-w-xl mt-3">
            (All names, locations, and quotes generated by an AI that has watched too much late-night infomercial content.)
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={i}
                className="relative bg-[#0a1628] border border-[#ffd700]/30 p-7 hover:border-[#ffd700] transition-all group"
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} size={14} className="fill-[#ffd700] text-[#ffd700]" />
                  ))}
                </div>
                <p className="font-display text-xl leading-snug text-white/90">"{t.quote}"</p>
                <div className="mt-6 pt-5 border-t border-[#ffd700]/20 flex items-center justify-between">
                  <span className="text-sm text-white/70">{t.name}</span>
                  <span className="font-accent text-[10px] tracking-[0.2em] text-[#ffd700]">
                    {t.rank}
                  </span>
                </div>
                <Crown
                  size={18}
                  className="absolute top-5 right-5 text-[#ffd700]/30 group-hover:text-[#ffd700] transition-colors"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============== BONUS TIERS ============== */}
      <section
        className="relative px-6 py-24 bg-cover bg-center"
        style={{ backgroundImage: `linear-gradient(rgba(5,11,20,0.92), rgba(5,11,20,0.92)), url(${GOLD})` }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="font-accent text-[11px] tracking-[0.4em] text-[#ffd700]">
              EXCLUSIVE BONUS LADDER
            </span>
            <h2 className="font-display text-5xl md:text-7xl font-black mt-3">
              <span className="text-white">Climb the </span>
              <span className="gold-text">Patriot Pyramid</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { tier: "BRONZE", price: "$100", packageId: "standard", perks: ["Bald Eagle Wallpaper (digital)", "Hand-typed thank-you note (AI)", "Spiritual sense of victory"] },
              { tier: "DIAMOND", price: "$200", packageId: "double", perks: ["Everything in BRONZE × 2", "Honorary Eagle Whisperer title", "Imaginary photo with a flag", "Free entry to next imaginary rally"], featured: true },
              { tier: "AMERICAN", price: "$250", packageId: "american", perks: ["Everything in DIAMOND + $50 of pure freedom", "Ceremonial digital cowboy hat", "Your name engraved on a fictional plaque", "Free patriot vibes (premium grade)"] },
            ].map((p, i) => (
              <div
                key={i}
                className={
                  "relative p-8 transition-all " +
                  (p.featured
                    ? "bg-[#b22234] border-4 border-[#ffd700] shadow-[0_0_60px_rgba(255,215,0,0.25)] md:-translate-y-4"
                    : "bg-[#0a1628] border border-[#ffd700]/40 hover:border-[#ffd700]")
                }
              >
                {p.featured && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#ffd700] px-4 py-1 font-accent text-[10px] tracking-[0.3em] text-[#050b14]">
                    MOST PATRIOTIC
                  </div>
                )}
                <div className="font-accent text-[14px] tracking-[0.4em] text-[#ffd700] mb-3">
                  {p.tier}
                </div>
                <div className="font-display text-7xl font-black gold-text">{p.price}</div>
                <ul className="mt-6 space-y-3 min-h-[140px]">
                  {p.perks.map((perk, k) => (
                    <li key={k} className="flex items-start gap-2 text-white/90">
                      <ChevronRight size={16} className="text-[#ffd700] mt-1 shrink-0" />
                      <span className="text-sm">{perk}</span>
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`tier-donate-${p.packageId}`}
                  onClick={() => startCheckout(p.packageId)}
                  disabled={loading}
                  className={
                    "w-full mt-7 font-accent text-[13px] tracking-[0.3em] py-3 border-2 transition-all disabled:opacity-60 " +
                    (p.featured
                      ? "bg-[#ffd700] text-[#050b14] border-[#050b14] hover:bg-white"
                      : "bg-transparent text-[#ffd700] border-[#ffd700] hover:bg-[#ffd700]/10")
                  }
                >
                  CLAIM {p.tier} →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============== CUSTOM AMOUNT SLIDER ============== */}
      <section className="relative px-6 py-24 bg-[#0a1628] border-y border-[#ffd700]/30">
        <div className="absolute inset-0 stars-bg opacity-20 pointer-events-none" />
        <div className="relative max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-3">
            <Sliders size={14} className="text-[#ffd700]" />
            <span className="font-accent text-[11px] tracking-[0.4em] text-[#ffd700]">
              FOR THE TRULY COMMITTED
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl font-black leading-tight">
            <span className="text-white">Set Your Own </span>
            <span className="gold-text italic">Glory Threshold.</span>
          </h2>
          <p className="mt-4 text-white/70 text-lg max-w-2xl">
            Tiers are for amateurs. Drag the bald-eagle slider to anywhere between
            <span className="text-[#ffd700]"> $10</span> and{" "}
            <span className="text-[#ffd700]">$10,000</span>. We won't ask why.
          </p>

          <div className="mt-12 bg-[#050b14] border-2 border-[#ffd700] p-8 md:p-12">
            <div className="text-center">
              <div
                data-testid="custom-amount-display"
                className="font-display text-[80px] md:text-[120px] font-black leading-none gold-text"
              >
                ${customAmount.toLocaleString()}
              </div>
              <div className="font-accent text-[12px] tracking-[0.3em] text-[#ffd700] mt-3">
                {customAmount >= 1000 ? "INSANE PATRIOT" :
                 customAmount >= 500 ? "ELITE PATRIOT" :
                 customAmount >= 250 ? "COMMITTED PATRIOT" :
                 customAmount >= 100 ? "RESPECTABLE PATRIOT" :
                 "ENTRY-LEVEL PATRIOT"}
              </div>
            </div>

            <div className="mt-10 px-2">
              <input
                data-testid="custom-amount-slider"
                type="range"
                min={10}
                max={10000}
                step={10}
                value={customAmount}
                onChange={(e) => setCustomAmount(Number(e.target.value))}
                className="w-full accent-[#ffd700] h-2"
                style={{
                  background: `linear-gradient(to right, #ffd700 0%, #ffd700 ${((customAmount - 10) / 9990) * 100}%, #1a2742 ${((customAmount - 10) / 9990) * 100}%, #1a2742 100%)`,
                  WebkitAppearance: "none",
                  borderRadius: 999,
                  outline: "none",
                }}
              />
              <div className="flex justify-between mt-2 text-[10px] tracking-widest text-white/40">
                <span>$10</span>
                <span>$1,000</span>
                <span>$2,500</span>
                <span>$5,000</span>
                <span>$10,000</span>
              </div>
            </div>

            {/* Quick-pick chips */}
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              {[50, 100, 250, 500, 1000, 2500, 5000].map((v) => (
                <button
                  key={v}
                  data-testid={`custom-quick-${v}`}
                  onClick={() => setCustomAmount(v)}
                  className={
                    "font-accent text-[11px] tracking-[0.25em] px-4 py-2 border transition-all " +
                    (customAmount === v
                      ? "bg-[#ffd700] text-[#050b14] border-[#ffd700]"
                      : "bg-transparent text-[#ffd700] border-[#ffd700]/50 hover:bg-[#ffd700]/10")
                  }
                >
                  ${v.toLocaleString()}
                </button>
              ))}
            </div>

            <button
              data-testid="donate-custom-amount"
              onClick={() => startCheckout("custom", customAmount)}
              disabled={loading}
              className="w-full mt-10 bg-gradient-to-b from-[#b22234] to-[#8b1827] hover:from-[#c92a40] text-white font-accent text-[18px] tracking-[0.25em] py-5 border-2 border-[#ffd700] transition-all disabled:opacity-60"
            >
              {loading ? "LAUNCHING…" : `UNLEASH $${customAmount.toLocaleString()} →`}
            </button>
          </div>
        </div>
      </section>

      {/* ============== FINAL CTA ============== */}
      <section className="relative px-6 py-28 bg-[#050b14] overflow-hidden">
        <div className="absolute inset-0 stars-bg opacity-40" />
        <div className="relative max-w-4xl mx-auto text-center">
          <Zap size={48} className="mx-auto text-[#ffd700] blink mb-6" />
          <h2 className="font-display text-6xl md:text-8xl font-black leading-[0.9]">
            <span className="text-white">DON'T BE A</span>
            <br />
            <span className="font-accent text-[#b22234] italic">PEASANT.</span>
          </h2>
          <p className="mt-6 text-white/70 text-lg max-w-2xl mx-auto">
            Eagles are watching. Tap that button. Double it. Become the legend you were always meant to be (in parody).
          </p>
          <button
            data-testid="final-donate-button-a"
            onClick={() => startCheckout()}
            disabled={loading}
            className="mt-10 pulse-cta inline-flex items-center gap-3 bg-gradient-to-b from-[#b22234] to-[#8b1827] text-white font-accent text-[24px] tracking-[0.2em] px-12 py-6 border-2 border-[#ffd700] transition-all disabled:opacity-60"
          >
            <Eye size={22} /> DONATE ${total} <ChevronRight size={28} />
          </button>
        </div>
      </section>
    </main>
  );
}

function Trust({ icon: Icon, text }) {
  return (
    <div className="flex items-center gap-2">
      <Icon size={14} className="text-[#ffd700]" />
      <span className="font-accent text-[10px] tracking-[0.25em] text-white/70">{text}</span>
    </div>
  );
}